import type { CmsPageFields } from '../page/types'

export type CmsBlockDescriptor = {
  contentType: string
  pageUrl: string
}

export type CmsBlockState = {
  data: CmsPageFields | null
  loading: boolean
  error: boolean
}

export type CmsBlocksState = Record<string, CmsBlockState>

export const CMS_BLOCK_FETCH_START = 'cmsBlocks/FETCH_START' as const
export const CMS_BLOCK_FETCH_SUCCESS = 'cmsBlocks/FETCH_SUCCESS' as const
export const CMS_BLOCK_FETCH_ERROR = 'cmsBlocks/FETCH_ERROR' as const

export type CmsBlockAction =
  | { type: typeof CMS_BLOCK_FETCH_START; key: string }
  | { type: typeof CMS_BLOCK_FETCH_SUCCESS; key: string; data: CmsPageFields }
  | { type: typeof CMS_BLOCK_FETCH_ERROR; key: string }

export function cmsBlockKey(descriptor: CmsBlockDescriptor): string {
  return `${descriptor.contentType}:${descriptor.pageUrl}`
}
